import { Route, Redirect } from 'react-router-dom';
import { Spin } from 'antd';
import Permission from './permission';
import { useDispatch, useSelector } from 'react-redux';
import { getAccessRoutes } from '../stores/actions';

export const PrivteRoute = ({ component: Component, pathUrl, actionsAllowed, isLoading = false, ...rest }: any) => {
    const dispatch = useDispatch();
    const authed = useSelector((state: any) => state.auth.authed);
    Permission.handleAddingPermisstion(actionsAllowed)
    Permission.handleAddingPath(pathUrl)
    return (
        <Route
            {...rest}
            render={props => {
                // Use Redux state for auth check - backend manages cookies (HttpOnly)
                // If API returns 401, interceptor will handle redirect
                // Don't redirect if we're still loading permissions
                if (isLoading) {
                    // Show loading spinner - don't redirect during initial load
                    return <Spin size="large" tip="Loading..." style={{ margin: '50px 0', display: 'block' }} />;
                }
                
                if (authed) {
                    return <Component {...props} />;
                } else {
                    dispatch(getAccessRoutes([]))
                    return (
                        <Redirect to='/log-in' />
                    )
                }
            }
            }
        />
    )
}

